// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1GyML","title":"ClientReferral_title__168IF","itemText":"ClientReferral_itemText__3A2K3"};